import { render, staticRenderFns } from "./ProductionHistory.vue?vue&type=template&id=fc71cab6&scoped=true"
import script from "./ProductionHistory.vue?vue&type=script&lang=js"
export * from "./ProductionHistory.vue?vue&type=script&lang=js"
import style0 from "./ProductionHistory.vue?vue&type=style&index=0&id=fc71cab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc71cab6",
  null
  
)

export default component.exports